/**
 * Toolbox "Games" gallery registry. Each entry drives a gallery card and, when
 * picked, a floating game window. `id` selects the component in the toolbox
 * window's @switch. Order + styling verbatim from the OTA-B2B-6 design.
 */
export type GameId = 'numbermatch' | 'memorymatch' | 'minesweeper' | '2048' | 'sudoku' | 'chess' | 'connectfour';
export type GameArtKind = 'num' | 'nm' | 'ms' | 'tf' | 'sd' | 'ch' | 'c4';

export interface GameDef {
  id: GameId;
  name: string;
  tag: string;
  accent: string;
  gradient: string;
  /** Card illustration kind. */
  art: GameArtKind;
  /** Window-title glyph (emoji). */
  glyph: string;
  /** Floating window width (px). */
  w: number;
}

export const GAME_DEFS: GameDef[] = [
  { id: 'numbermatch', name: 'Number Match', tag: 'Match · lines', accent: '#f97316', gradient: 'linear-gradient(135deg,#c2410c,#fb923c)', art: 'num', glyph: '➕', w: 470 },
  { id: 'memorymatch', name: 'Memory Match', tag: 'Memory · pairs', accent: '#8b5cf6', gradient: 'linear-gradient(135deg,#6d28d9,#a78bfa)', art: 'nm', glyph: '🔢', w: 360 },
  { id: 'minesweeper', name: 'Minesweeper', tag: 'Logic · 3 levels', accent: '#0ea5e9', gradient: 'linear-gradient(135deg,#0369a1,#38bdf8)', art: 'ms', glyph: '💣', w: 520 },
  { id: '2048', name: '2048', tag: 'Merge · numbers', accent: '#f59e0b', gradient: 'linear-gradient(135deg,#b45309,#fbbf24)', art: 'tf', glyph: '▦', w: 360 },
  { id: 'sudoku', name: 'Sudoku', tag: 'Logic · numbers', accent: '#10b981', gradient: 'linear-gradient(135deg,#047857,#34d399)', art: 'sd', glyph: '#', w: 360 },
  { id: 'chess', name: 'Chess', tag: 'Strategy · 2P', accent: '#e879a6', gradient: 'linear-gradient(135deg,#7c2d4d,#f0a6c4)', art: 'ch', glyph: '♞', w: 384 },
  { id: 'connectfour', name: 'Connect Four', tag: 'Drop · 2P', accent: '#ef4444', gradient: 'linear-gradient(135deg,#b91c1c,#fca5a5)', art: 'c4', glyph: '●', w: 384 },
];
